var AppDispatcher = require('../core/AppDispatcher.jsx');
var Constants = require('../constants/AdviserFeeConstants.js');

var ActionTypes = Constants.ActionTypes;

module.exports = {
    loadAdviceFee: function (adviceFeeList) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.RECEIVE_ADVICE_FEE_LIST,
            adviceFeeList: adviceFeeList
        });
    },
    addAdviserFee: function (fieldId, value) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.ADD_ADVISER_FEE,
            fieldId: fieldId,
            value: value
        });
    },
    removeSingleRecord: function (index) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.REMOVE_SINGLE_RECORD,
            index: index
        });
    },
    getInvestmentList: function (index, frequency) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.GET_INVESTMENT_LIST,
            index: index,
            frequency: frequency
        });
    },
    getExcessiveFeeCheckResult: function (result) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.GET_EXCESSIVE_FEE_CHECK_RESULT,
            result: result
        });
    },
    updateAdviceFee: function (idx, fieldId, value) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.UPDATE_ADVICE_FEE,
            idx: idx,
            fieldId: fieldId,
            value: value
        });
    }
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./actions/AdviceFeeAction.js